(function () {
    "use strict";

    angular.module("app.productDetail").controller("ProductDetailController", ProductDetailController);

    ProductDetailController.$inject = ["$scope", "ProductDetailService"];

    function ProductDetailController($scope, ProductDetailService) {
        /* jshint validthis:true */
        var vm = this;
        vm.priceList = [];
        vm.selectedVariant = {};

        function activate() {}

        window.addEventListener(
            "hashchange",
            function () {
                $scope.$apply();
            },
            false
        );

        $scope.$watch(
            function () {
                return location.href;
            },
            function (value) {
                if (value) {
                    var hash = decodeURI(value.split("#")[1]);

                    if (hash) {
                        vm.selectedVariant = vm.priceList.find(function (item) {
                            return item.Code === hash || item.Code === 'main'
                        });
                    } 
   
                }
            }
        );

        activate();
    }
})();
